import { GameHistoryHealthReportService } from './../../../services/game-history-health-report.service';
import { DatePipe } from '@angular/common';
import { Component, OnInit, DoCheck, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Observable, of } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { GenericMetricFormatterPipe } from 'src/app/reusables/pipes/generic-metric-formatter.pipe';
import { GamesService } from '../../../services/games.service';
import { GamesDetailsModalComponent } from '../games-details-modal/games-details-modal.component';
import { RevertPayoutDetailsComponent } from '../revert-payout-details/revert-payout-details.component';
import { GamesHistoryTableComponent } from '../tables/games-history-table/games-history-table.component';
import { MarketplaceOrderStatus } from '../../../models/marketplace-order.model';
import { GamesParameterHistoryService } from '../../../services/games-parameter-history.service';
import { standardizeParticipants } from '../../../models/games-parameter-history';
import { isBracket, isConnect3, isConnectAll, isTopTeam } from '../../../models/games-player-breakdown';
import { HistoricalTeamObj, IHGameStandardize } from '../../../models/games-parameter.model';
import { GamesHistoryHealthReportComponent } from '../games-history-health-report/games-history-health-report.component';

type CustomReward = {
  PointStoreProductID: number;
  Title: string;
};

type RaffleRewardsProducts = {
  [key: number]: CustomReward;
};

enum HistoryView {
  GameBreakdown,
  PlayerBreakdown
}

@Component({
  selector: 'cv-games-history',
  templateUrl: './games-history.component.html',
  styleUrls: ['./games-history.component.scss']
})

export class GamesHistoryComponent implements OnInit {
  @ViewChild(GamesHistoryTableComponent, { static: false }) historyTable: GamesHistoryTableComponent;
  @ViewChild(GamesHistoryHealthReportComponent) healthReportComponent!: GamesHistoryHealthReportComponent;

  gs = null;
  gamesListObject = [];
  isLoading: boolean = false;

  orderBy = {
    key: 'EndDate',
    reversed: true,
  };

  gridData = [];
  participantsInfo = [];
  teamsInfo: { [key: number]: HistoricalTeamObj } = {};
  actionHistory: any = [];
  raffleRewardsProducts: RaffleRewardsProducts = {};

  //Revert Payments variables
  selectAll: boolean = false;
  reversion: boolean = false;
  showModal: boolean = false;
  modalFlag: boolean = false;

  searchGameText: string = "";
  searchIntervalText: string = "";
  enableSelection: boolean = false;

  //Observables
  filteredGames$: Observable<Array<any>> = new Observable<[]>();
  filteredIntervals$: Observable<Array<any>> = new Observable<[]>();

  oldHistoryItems: number = 0;
  oldSelectedInterval: any = null;
  oldModalResponse: string = "";
  intervalForDisplay: any;
  abortRequest = {};

  dropdownOpen: boolean = false;
  alreadyFormatted = false;
  participantsInfoExport = [];
  gmf = null;
  columns: any;
  totalRow: any;
  exportData: any;
  exportHealthReportData: any;
  startDate: any = "any";
  endDate: any = "";
  HistoryView = HistoryView;
  selectedHistoryView: HistoryView = HistoryView.GameBreakdown;
  hGame: IHGameStandardize;
  gameActions = null;

  constructor(
    private datePipe: DatePipe,
    private modalService: NgbModal,
    private gamesService: GamesService,
    private navigationService: NavigationService,
    private metricFormatPipe: GenericMetricFormatterPipe,
    private cdr: ChangeDetectorRef,
    private gameHistoryHealthReport: GameHistoryHealthReportService,
    private gamesParameterHistoryService: GamesParameterHistoryService
  ) {
    this.gs = this.gamesService.data;
  }

  ngOnInit(): void {
    if (this.gs.GameFolders.length > 0) {

      this.loadGamesList();
      if (this.gs.selectedInterval && this.gs.selectedInterval.length > 0) {
        this.gameHistoryHealthReport.updateIntervalSelected(this.gs.selectedInterval)
      }
    } else {
      this.isLoading = true;
    }
  }

  ngDoCheck(): void {
    const currentHistoryLength = this.gs.GameFoldersForHistory.length;
    if (this.oldHistoryItems !== currentHistoryLength) {
      this.oldHistoryItems = currentHistoryLength;
      this.loadGamesList();
      this.cdr.detectChanges();
    }

    const selectedInterval = this.gs.selectedInterval[0];
    if (JSON.stringify(this.oldSelectedInterval) !== JSON.stringify(selectedInterval)) {
      this.oldSelectedInterval = selectedInterval;
      this.updateSelectedInterval();
      this.cdr.detectChanges();
    }

    if (this.oldModalResponse !== this.gs.modalResponse) {
      this.oldModalResponse = this.gs.modalResponse;
      this.handleModalResponse();
      this.cdr.detectChanges();
    }
  }

  private updateSelectedInterval(): void {
    if(this.gs && this.gs.selectedInterval.length === 0) {
      this.gs.selectedInterval[0] = this.gs.selectedGame[0].Intervals[0];
      this.gs.selectedInterval[0].isSelected = true;
    }

    if (this.gs.selectedInterval.length > 0) {
      this.gameHistoryHealthReport.updateIntervalSelected(this.gs.selectedInterval)
      const ruleID = this.gs.selectedGame[0].underlyingRule.RuleID;
      const SelectedEndDate = this.gs.selectedInterval[0].EndDate;
      const endDate = SelectedEndDate?.split('T')[0] || SelectedEndDate;
      this.changeTableOverlay(true);
      this.gamesParameterHistoryService.loadGameHistoryParams(ruleID, endDate).then((hGame: IHGameStandardize) => {
        this.hGame = hGame;
        this.exportHealthReportData = null;
        this.loadGamesHistory();
      });
    } else {
      this.clearDataTable();
    }
  }

  private handleModalResponse(): void {
    if (this.gs.modalResponse === "PaymentReverted") {
      if (this.hGame.RuleID) {
        this.gamesService.clearRewardsHistory();
      }
      this.loadGamesHistory();
    }
    this.gs.modalResponse = "";
  }

  clearDataTable() {
    this.participantsInfo = [];
    this.enableSelection = false;
    this.selectAll = false;
    this.reversion = false;
    this.exportHealthReportData = null;
  }

  openGameDetail() {
    if (!(this.gs.selectedGame.length > 0))
      return;

    //Sort rewards of Milestone
    if (this.gs.selectedGame[0].GameType == 5) {
      this.gs.selectedGame[0].MilestoneRewards.sort((a, b) => { return (a.RuleLevelID < b.RuleLevelID) ? 1 : -1 });
    }

    const modalRef = this.modalService.open(GamesDetailsModalComponent, {
      ariaDescribedBy: 'card-body',
      backdrop: 'static',
      backdropClass: 'stopScrolling',
      size: 'modal-dialog-noborder-when-loading modal-dialog-centered modal-sm-custom',
    });
    modalRef.componentInstance.hGame = this.hGame;

    modalRef.result.finally(() => {
      this.navigationService.showOverlay = false;
    });
  }

  loadGamesList() {
    this.filteredGames$ = of([]);
    this.isLoading = true;
    this.gs.gamesList = [];
    let tmpList = angular.copy(this.gs.GameFolders);
    this.gs.gamesList = this.formatGamesList(tmpList, this.gs.selectedGame[0]);
    this.filteredGames$ = of(JSON.parse(JSON.stringify(this.gs.gamesList)));
    this.isLoading = false;
    this.participantsInfo = [];
  }

  filterGames() {
    this.isLoading = true;
    var folder = null;
    var tmpData = [];
    this.filteredGames$ = of([]);
    var rawData = JSON.parse(JSON.stringify(this.gs.gamesList));

    for (var i = 0; i < rawData.length; i++) {
      if (rawData[i].gameFolderGroup != undefined && rawData[i].gameFolderGroup == true) {
        folder = rawData[i];
      }

      if (rawData[i].underlyingRule != undefined && rawData[i].underlyingRule.RuleName.toLowerCase().indexOf(this.searchGameText.toLowerCase()) > -1) {
        if (folder.length != 0 && !tmpData.includes(rawData[i - 1])) {
          tmpData.push(folder);
          folder = [];
        }

        tmpData.push(rawData[i]);
      }
    }

    this.filteredGames$ = of(JSON.parse(JSON.stringify(tmpData)));
    this.isLoading = false;
  }

  filterIntervals() {
    this.isLoading = true;
    var tmpData = [];
    this.filteredIntervals$ = of([]);
    var rawData = JSON.parse(JSON.stringify(this.gs.selectedGame[0].Intervals));

    for (var i = 0; i < rawData.length; i++) {
      if (rawData[i].DisplayStringDate.indexOf(this.searchIntervalText.toLocaleLowerCase()) > -1) {
        tmpData.push(rawData[i]);
      }
    }

    this.filteredIntervals$ = of(JSON.parse(JSON.stringify(tmpData)));
    this.isLoading = false;
  }

  /**
   * We need to cancel the request if the loadGameHistory is called again
   */
  loadGamesHistory() {
    this.changeTableOverlay(true);// show overlay
    this.enableSelection = false;
    this.selectAll = false;
    this.reversion = false;

    $(document).trigger(new jQuery.Event('cancelRevertSelection'));
    var ruleID = this.gs.selectedGame[0].underlyingRule.RuleID;
    var SelectedStartDate = this.gs.selectedInterval[0].StartDate;
    var SelectedEndDate = this.gs.selectedInterval[0].EndDate;

    this.endDate = this.gs.selectedInterval[0].EndDate;
    this.startDate = this.gs.selectedInterval[0].StartDate;

    var participants = null;
    this.participantsInfo = null;

    let bracketID;
    let previousRequest;

    //sort rewards of Milestone
    if (this.gs.selectedGame[0].GameType == 5) {
      this.gs.selectedGame[0].MilestoneRewards.sort((a, b) => { return (a.RuleLevelID < b.RuleLevelID) ? 1 : -1 });
    }

    //Get all the participants by Rule and Interval
    if (this.gs.selectedGame[0].GameType == 10) {
      let currentVersion = this.gs.selectedInterval[0].Version;

      const highestVersion = this.gs.selectedGame[0].Intervals.reduce((max, item) => (item.Version > max.Version ? item : max), this.gs.selectedGame[0].Intervals[0]).Version;

      if (currentVersion == highestVersion) {
        bracketID = this.gs.selectedGame[0].BracketTournamentDetails.BracketID;
        this.gs.selectedGame[0].HistoryBracketTournamentDetails = this.gs.selectedGame[0].BracketTournamentDetails;
        this.gs.selectedGame[0].HistoryBracketTournamentMatches = this.gs.selectedGame[0].BracketTournamentMatches;
        this.gs.selectedGame[0].HistoryBracketTournamentRounds = this.gs.selectedGame[0].BracketTournamentRounds;
        this.gs.selectedGame[0].HistoryEligibility = this.gs.selectedGame[0].Eligibility;
        previousRequest = Promise.resolve();
      } else {
        previousRequest = this.gs.selectedGame[0].HistoryBracketTournament = this.gamesService.getBracketMatchesByVersion(ruleID, this.gs.selectedInterval[0].Version).then((result: any) => {//TODO: Add the correct type
          this.gs.selectedGame[0].HistoryBracketTournamentDetails = result.TournamentDetails;
          this.gs.selectedGame[0].HistoryBracketTournamentMatches = result.TournamentMatches;
          this.gs.selectedGame[0].HistoryBracketTournamentRounds = result.TournamentRounds;
          this.gs.selectedGame[0].HistoryEligibility = result.HistoryEligibility;

          bracketID = this.gs.selectedGame[0].HistoryBracketTournamentDetails.BracketID;
        });
      }
    } else {
      previousRequest = Promise.resolve();
    }

    previousRequest.then(() => {
      this.gamesService.getParticipantsByRule(ruleID, SelectedStartDate, SelectedEndDate, bracketID).then((result: any) => {
        const prevRequest = this.getRequestId(ruleID, SelectedStartDate);
        if (this.abortRequest[prevRequest]) {
          this.abortRequest[prevRequest] = false;
          return Promise.reject();
        }
        //Avoiding duplicated participants
        this.teamsInfo = result.filter(p => !!p.team).reduce((acc, element) => ({
            ...acc,
            [element.team?.TeamID]: {
                ...element.team,
                metricsValues: element.metricsValues
            }
        }), {});
        participants = result.filter(p => !!p.participant)?.filter((currentElement, index, selfArray) => {
            return index === selfArray.findIndex((t) => {
                return t.participant.LoginID === currentElement.participant.LoginID;
            });
        });
        // get current rewards
        return this.gamesService.getRewardsByGameInterval(ruleID, SelectedStartDate, SelectedEndDate);
      }).then((response) => {
        this.actionHistory = response;

        //GHR: We need the BE and Milestones action history records to count how many times the levels have been received
        if (this.gs.selectedGame[0].GameType == 3 || this.gs.selectedGame[0].GameType == 5)
          this.gameActions = this.actionHistory;
        const tournamentInfo = isBracket(this.gs.selectedGame[0].GameType) ? {
          matches: this.gs.selectedGame[0].HistoryBracketTournamentMatches,
          NumberOfRounds: this.gs.selectedGame[0]?.HistoryBracketTournamentDetails?.NumberOfRounds || 0,
        } : {};
        const endDate = SelectedEndDate.split('T')[0] || SelectedEndDate;
        const hGame = this.gamesParameterHistoryService.getGame(ruleID, endDate);
        participants = standardizeParticipants({
          participants, 
          actionHistory: this.actionHistory,
          game: hGame,
          localizationFn: this.gamesService.getLocalizedMessage.bind(this.gamesService),
          tournamentInfo,
          transformDateFn: this.datePipe.transform.bind(this.datePipe),
          teamsInfo: this.teamsInfo,
        });

        this.participantsInfo = participants?.sort((a, b) => {
          return (a.calculatedCoins > b.calculatedCoins) ? -1 : ((a.calculatedCoins < b.calculatedCoins) ? 1 : 0);
        }) || [];
        this.participantsInfoExport = this.participantsInfo;

        if (this.historyTable && this.historyTable.grid && this.historyTable.grid.api)
          this.historyTable.agGrid.api.hideOverlay();
      });
    });
  }

  displayModal(object: any) {
    this.showModal = true;
    this.reversion = false;
    const shouldDisplayCustomRewardMessage = (this.gs.selectedGame[0]?.GameType == 9 || this.gs.selectedGame[0]?.GameType == 10);
    const validOrderStatus = [MarketplaceOrderStatus.ReadyForPickup, MarketplaceOrderStatus.Created, MarketplaceOrderStatus.Processing];
    const isNotValidStatus = (object?: { productState?: number }): boolean => {
      return object && object.productState !== undefined && object.productState !== -1 && !validOrderStatus.includes(object.productState)
    }

    var gridData = [];
    var reversionObj: any = {
      ruleID: this.gs.selectedGame[0].RuleID,
      ruleName: this.gs.selectedGame[0].RuleName,
      startDate: this.gs.selectedInterval[0].StartDate,
      endDate: this.gs.selectedInterval[0].EndDate
    };

    if (object.length > 0) {
      for (var i = 0; i < this.gs.selectedInterval.length; i++) {
        for (var j = 0; j < object.length; j++) {
          var tmpObject: any = {};
          tmpObject.interval = this.gs.selectedInterval[i].DisplayStringDate;
          tmpObject.loginID = object[j].participant.LoginID;
          tmpObject.coins = object[j].calculatedCoins;
          tmpObject.xp = object[j].calculatedXP;
          tmpObject.badges = object[j].badges.length;
          tmpObject.teamID = object[j].participant.TeamID;
          tmpObject.teamName = object[j].participant.Team;
          tmpObject.custom = +(!!object[j].custom && !isNotValidStatus(object[j]));// empty string will be 0 and not empty string will be 1

          gridData.push(tmpObject);
        }
      }

      reversionObj.data = gridData;
      this.navigationService.showOverlay = true;

      const modalRef = this.modalService.open(RevertPayoutDetailsComponent, {
        animation: true,
        backdropClass: 'stopScrolling',
        size: 'lg modal-dialog-noborder-when-loading modal-dialog-centered'
      });

      modalRef.componentInstance.payouts = reversionObj;
      modalRef.componentInstance.shouldDisplayCustomRewardMessage = shouldDisplayCustomRewardMessage;

      modalRef.result.catch(() => {
        //If the user confirmed the payment reversion and after that clicks outside the confirmBox
        //GameHistory table will reloaded
        if (this.gs.confirmBox) {
          if (this.hGame.RuleID) {
            this.gamesService.clearRewardsHistory();
          }
          this.loadGamesHistory();
        }
      }).finally(() => {
        this.navigationService.showOverlay = false;
        this.showModal = false;
      });
    }
  }

  getClass() {
    return this.enableSelection ? 'btn btn-secondary' : 'btn btn-text body-2';
  }

  get metricsToDisplay() {
    if (!this.hGame) return [];
    if (isConnect3(this.hGame.GameType) || isConnectAll(this.hGame.GameType)) {
      return this.hGame.Connect3Definition;
    }
    return [this.hGame.metricDefinition];
  }

  selection () {
    if (this.participantsInfo.length > 0 && !this.enableSelection) {
      this.enableSelection = true;
    } else if (this.enableSelection) {
      this.enableSelection = false;
    }
  }

  getTextButton() {
    return this.enableSelection ? "Revert_Payments" : "Cancel_Revert_Payments";
  }

  formatGamesList(gamesFolderList, selectedGame) {
    var gamesListTemp = [];
    var isFirstElement = true;

    angular.forEach(gamesFolderList, (gameFolder, key) => {
      if (gameFolder.Games.length > 0) {
        gamesListTemp.push({ RuleName: gameFolder.FolderData.FolderName, gameFolderGroup: true });

        angular.forEach(gameFolder.Games, (gameObject, key) => {
          gameObject.GameObject.underlyingRule.icon = '<div class="glGame-list-icon ' + gameObject.GameObject.iconClass + '"></div>';
          gameObject.GameObject.underlyingRule.RuleName = this.escapeChart(gameObject.GameObject.underlyingRule.RuleName);
          gameObject.GameObject.underlyingRule.isActive = gameObject.GameObject.isActive;
          gameObject.GameObject.underlyingRule.isSelected = selectedGame != null ? gameObject.GameObject.underlyingRule.RuleID == selectedGame.underlyingRule.RuleID : isFirstElement;
          gamesListTemp.push(Object.assign({}, gameObject.GameObject, gameObject.GameObject.underlyingRule));
          isFirstElement = false;

          //Just to check if connect 3 will require a free space in the middle
          if ((gameObject.GameObject.underlyingRule.GameType == 6 || gameObject.GameObject.underlyingRule.GameType == 7) && gameObject.GameObject.Connect3Positions.length == 8) {
            gameObject.GameObject.Connect3Positions.splice(4, 0, { position: 4, metric: { abbrev: this.gamesService.getLocalizedMessage("Free_Space", "Free Space"), name: this.gamesService.getLocalizedMessage("Free_Space", "Free Space"), metricID: -1, target: null } });
          }

          var isFirstInterval = true;
          angular.forEach(gameObject.GameObject.Intervals, (interval, key) => {
            interval.DisplayStringDate = this.datePipe.transform(interval.StartDate, CVAngularDateFormat) + ' - ' + this.datePipe.transform(interval.EndDate, CVAngularDateFormat);
            if (gameObject.GameObject.underlyingRule.isSelected) {
              interval.isSelected = isFirstInterval;
              isFirstInterval = false;
            } else {
              interval.isSelected = false;
            }
            // Excluding Interval End Date when it is greater than Game's EndDate
            if (gameObject.GameObject.underlyingRule.EndDate != null && ((gameObject.GameObject.Intervals.length - 1) == key)) {
              var EndDate = this.datePipe.transform(gameObject.GameObject.underlyingRule.EndDate, CVAngularDateFormat);
              var intervalEndDate = this.datePipe.transform(interval.EndDate, CVAngularDateFormat);
              if (intervalEndDate > EndDate && gameObject.GameObject.underlyingRule.GameType != 10)
                interval.DisplayStringDate = this.datePipe.transform(interval.StartDate, CVAngularDateFormat);
            }

            if (interval.isSelected) {
              this.gs.selectedInterval = [];
              this.gs.selectedInterval.push(interval);
            }
          });

          // Saving game intervals
          if (gameObject.GameObject.underlyingRule.isSelected) {
            this.filteredIntervals$ = of(JSON.parse(JSON.stringify(gameObject.GameObject.Intervals ?? selectedGame.Intervals)));
          }
        });

        gamesListTemp.push({ gameFolderGroup: false });
      }

      this.gs.selectedGame[0] = gamesListTemp.filter((item) => { return item.underlyingRule != undefined && item.isSelected })[0];
    });

    if (this.gs.selectedGame[0].Intervals == null)
      this.gs.selectedGame[0].Intervals = selectedGame.Intervals;
    return gamesListTemp;
  }

  escapeChart(value: string) {
    var tagsToReplace = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;'
    };

    return value.replace(/[&<>]/g, (tag) => {
      return tagsToReplace[tag] || tag;
    });
  }

  setSelectedGame(game: any) {
    if (this.gs.selectedGame[0] != game) {
      if (this.historyTable && this.historyTable.grid && this.historyTable.grid.api)
        this.historyTable.agGrid.api.hideOverlay();
      this.removeCurrentInterval();
      this.changeRequestAbortStatus(true);
      game.underlyingRule.isSelected = true;

      this.gs.selectedInterval = [];
      this.filteredGames$ = of([]);
      this.filteredIntervals$ = of([]);
      this.gameHistoryHealthReport.updateIntervalSelected(this.gs.selectedInterval);

      this.gs.gamesList.forEach((g) => {
        if (g.underlyingRule != undefined && game.RuleID != g.RuleID) {
          g.underlyingRule.isSelected = false;
        }

        if (g.underlyingRule != undefined && game.RuleID == g.RuleID) {
          g.underlyingRule.isSelected = game.underlyingRule.isSelected;
        }
      });

      this.gs.selectedGame[0] = game;
      this.filteredGames$ = of(JSON.parse(JSON.stringify(this.gs.gamesList)));
      this.filteredIntervals$ = of(JSON.parse(JSON.stringify(this.gs.selectedGame[0].Intervals)));
    }
  }

  getRequestId(ruleID?: number, startDate?: string) {
    const currentRuleId = ruleID || this.gs.selectedGame[0]?.RuleID;
    const currentStartDate = this.gs.selectedInterval && this.gs.selectedInterval.length > 0 && this.gs.selectedInterval[0].StartDate;
    const date = startDate ? startDate : currentStartDate;
    if (currentRuleId && date) {
      const prevRequest = `${currentRuleId}-${date}`;
      return prevRequest;
    }
    return '';
  }

  /**
   * 
   * @param status: if status is true, then the request will finish without update the data, if is false then the request will continue normally
   * @param ruleID: the rule id, if there is no rule id we will take the current rule id used in the request, this is use when the user change interval and go back to the same rule with the same interval
   */
  changeRequestAbortStatus(status: boolean = false, ruleID?: number, startDate?: string) {
    const requestId = this.getRequestId(ruleID, startDate);
    this.abortRequest[requestId] = status;
  }

  changeTableOverlay(display = false) {
    if (this.historyTable && this.historyTable.agGrid && this.historyTable.agGrid.api) {
      if (display) this.historyTable.agGrid.api.showLoadingOverlay();
      else this.historyTable.agGrid.api.hideOverlay();
    }
  }

  removeCurrentInterval() {
    this.gs.selectedGame[0].Intervals.filter(i => i.isSelected).forEach((i) => {
      i.isSelected = false;
    });
  }

  setSelectedInterval(interval: any) {
    if (interval.isSelected) {
      return;
    }
    if (this.gs.selectedInterval && this.gs.selectedInterval.length > 0) {
      const currentInterval = this.gs.selectedInterval.find(i => i.EndDate === interval.EndDate && i.StartDate === interval.StartDate && i.isSelected);
      if (currentInterval) {
        interval.isSelected = true;
        return;
      }
    }
    
    interval.isSelected = !interval.isSelected;
    this.changeRequestAbortStatus(true);// we cancel the current status of the request
    this.changeTableOverlay(true);

    if (interval.isSelected == true) {
      this.filteredIntervals$ = of([]);

      this.gs.selectedGame[0].Intervals.forEach((i) => {
        if (i.DisplayStringDate == interval.DisplayStringDate) {
          i.isSelected = interval.isSelected;
        } else {
          i.isSelected = false;
        }
      });

      this.gs.selectedInterval = [];
      this.gs.selectedInterval.push(interval);
      this.filteredIntervals$ = of(JSON.parse(JSON.stringify(this.gs.selectedGame[0].Intervals)));
      this.changeRequestAbortStatus(false);// if there was a request with this id, then we should allow the request to continue 
    }
  }

  revert(): void {
    this.reversion = true;
    this.cdr.detectChanges();
  }

  onInputChange(newValue: boolean) {
    this.selectAll = newValue;
  }

  getFormattedMetric(value, format): string {
    return this.metricFormatPipe.transform(value, format);
  }

  getLocalizedText(key: string, defaultText: string): string {
    return this.gamesService.getLocalizedMessage(key, defaultText);
  }

  getCommonText(key: string, defaultText: string): string {
    return this.gamesService.getCommonMessage(key, defaultText);
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  setColumns(obj) {
    this.columns = obj;
  }

  setTotalRow(obj) {
    this.totalRow = obj;
    this.totalRow.badgest = this.totalRow.badges;
  }

  setParticipantsSorted(obj) {
    this.participantsInfoExport = obj;
    this.alreadyFormatted = false;
  }

  exportHistory() {

    this.exportData = {
      ghObjects: this.participantsInfoExport,
      game: {
        ...this.hGame,
        MetricDefinition: this.hGame.metricDefinition,
        QualifierDefinition: this.hGame.qualifierDefinition
      },
      columnStates: this.columns || [],
      totalRow: this.totalRow !== 'undefined' ? this.totalRow : null
    }
    this.alreadyFormatted = true;
  }

  async exportGameHealthHistory() {
    if (this.healthReportComponent && !this.exportHealthReportData) {
      this.alreadyFormatted = false;
      this.exportHealthReportData = await this.healthReportComponent.setDataForexportGHR();
      this.alreadyFormatted = true;
      this.cdr.detectChanges();
    }
  }
  
}
